import React from "react";
import { useFormContext } from "react-hook-form";
import Input from "Components/UI/Input";
import { stringToPointNumber } from "MainPages/Utils/decimal.utils";
import dayjs from "dayjs";
import {
  useFormattedVehicleCategoryOption,
  useFormattedVehicleTypeOption,
} from "core/Operations/formattedOption/useFormattedMasterOptions";
import PropTypes from "prop-types";
import InputWarningMessage from "Components/UI/InputWarningMessage";

const isStatusOption = [
  { id: 1, label: "Active", value: true },
  { id: 0, label: "Inactive", value: false },
];

const Vehicle = ({ companyCode }) => {
  const {
    watch,
    setValue,
    trigger,
    register,
    formState: { errors },
  } = useFormContext();

  const vehicleTypeOptions = useFormattedVehicleTypeOption(companyCode);

  const vehicleCategoryOptions = useFormattedVehicleCategoryOption(companyCode);
  const index = 0;
  return (
    <>
      <div className="form-row row">
        <h4 className="header-title">Vehicle Information</h4>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].vehicleNumber`}
            type="text"
            placeholder="Vehicle Number"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.vehicleNumber
                ? "is-invalid"
                : ""
            }`}
            label="Vehicle Number"
            labelClassName="form-label"
            required={true}
            requiredMessage="Vehicle Number is required"
            defaultValue=""
          />
        </div>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].vehicleName`}
            type="text"
            placeholder="Vehicle Name"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.vehicleName
                ? "is-invalid"
                : ""
            }`}
            label="Vehicle Name"
            labelClassName="form-label"
            required={true}
            requiredMessage="Vehicle Name is required"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].vehicleType`}
            type="commonSelect"
            placeholder="Vehicle Type"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.vehicleType
                ? "is-invalid"
                : ""
            }`}
            optionData={vehicleTypeOptions?.map((x) => {
              return { label: x.label, value: x.value.toString() };
            })}
            label="Vehicle Type"
            labelClassName="form-label"
            required={true}
            requiredMessage="Vehicle Type is required"
            defaultValue=""
            onSelect={(selectedOption) =>
              setValue(
                `vehicleInformationList[${index}].vehicleType`,
                selectedOption
              )
            }
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].company`}
            type="text"
            placeholder="Company"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.company
                ? "is-invalid"
                : ""
            }`}
            label="Company"
            labelClassName="form-label"
            required={true}
            requiredMessage="Company is required"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].department`}
            type="text"
            placeholder="Department"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.department
                ? "is-invalid"
                : ""
            }`}
            label="Department"
            labelClassName="form-label"
            required={true}
            requiredMessage="Department is required"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].iuLabelNumber`}
            type="text"
            placeholder="IU Label Number"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.iuLabelNumber
                ? "is-invalid"
                : ""
            }`}
            label="IU Label Number"
            labelClassName="form-label"
            required={false}
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].chassisNumber`}
            type="text"
            placeholder="Chassis Number"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.chassisNumber
                ? "is-invalid"
                : ""
            }`}
            label="Chassis Number"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].vehicleModel`}
            type="text"
            placeholder="Vehicle Model"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.vehicleModel
                ? "is-invalid"
                : ""
            }`}
            label="Vehicle Model"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].vehicleCategory`}
            type="commonSelect"
            placeholder="Vehicle Category"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.vehicleCategory
                ? "is-invalid"
                : ""
            }`}
            optionData={vehicleCategoryOptions?.map((x) => {
              return { label: x.label, value: x.value.toString() };
            })}
            label="Vehicle Category"
            labelClassName="form-label"
            required={true}
            requiredMessage="Vehicle Category is required"
            defaultValue=""
            onSelect={(selectedOption) =>
              setValue(
                `vehicleInformationList[${index}].vehicleCategory`,
                selectedOption
              )
            }
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].propellant`}
            type="text"
            placeholder="Propellant"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.propellant
                ? "is-invalid"
                : ""
            }`}
            label="Propellant"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].assetTagNo`}
            type="text"
            placeholder="Asset TagNo"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.assetTagNo
                ? "is-invalid"
                : ""
            }`}
            label="Asset TagNo"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].gpsSimNo`}
            type="text"
            placeholder="gpsSimNo"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.gpsSimNo
                ? "is-invalid"
                : ""
            }`}
            label="GPS SimNo"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].requireTill`}
            type="date"
            placeholder="Require Till"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.requireTill
                ? "is-invalid"
                : ""
            }`}
            label="Require Till"
            labelClassName="form-label"
            required={true}
            requiredMessage="requireTill is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("requireTill"), "YYYY-MM-DD") || ""}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].registerDate`}
            type="date"
            placeholder="Register Date"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.registerDate
                ? "is-invalid"
                : ""
            }`}
            label="Register Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Register Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("registerDate"), "YYYY-MM-DD") || ""}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].fine`}
            type="text"
            placeholder="Fine"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.fine
                ? "is-invalid"
                : ""
            }`}
            label="Fine"
            labelClassName="form-label"
            // onChange={(e) => stringToPointNumber(e.target.value)}
            // defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].vehicleBelongsTo`}
            type="text"
            placeholder="Vehicle BelongsTo"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.vehicleBelongsTo
                ? "is-invalid"
                : ""
            }`}
            label="Vehicle BelongsTo"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].category`}
            type="text"
            placeholder="Category"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.category
                ? "is-invalid"
                : ""
            }`}
            label="Category"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].remarks`}
            type="text"
            placeholder="Remarks"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.remarks
                ? "is-invalid"
                : ""
            }`}
            label="Remarks"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].isActive`}
            type="commonSelect"
            placeholder=""
            className={`form-control select ${
              errors?.vehicleInformationList?.[`${index}`]?.isActive
                ? "is-invalid"
                : ""
            }`}
            label="Active Status"
            labelClassName="form-label"
            optionData={isStatusOption}
            required={true}
            requiredMessage="Status is required"
            onChange={(selectedOption) => {
              setValue(
                `vehicleInformationList[${index}].isActive`,
                selectedOption?.value
              );
              trigger(`vehicleInformationList[${index}].isActive`);
            }}
            defaultValue={watch(`vehicleInformationList[${index}].isActive`)}
          />
        </div>
      </div>

      <div className="form-row row">
        <h4 className="header-title">Cost</h4>
        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].cost`}
            type="text"
            placeholder="cost"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.cost
                ? "is-invalid"
                : ""
            }`}
            label="Cost"
            labelClassName="form-label"
            // onChange={(e) => stringToPointNumber(e.target.value)}
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].purchaseCost`}
            type="text"
            placeholder="purchaseCost"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.purchaseCost
                ? "is-invalid"
                : ""
            }`}
            label="Purchase Cost"
            labelClassName="form-label"
            // onChange={(e) => stringToPointNumber(e.target.value)}
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].purchaseFrom`}
            type="text"
            placeholder="purchaseFrom"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.purchaseFrom
                ? "is-invalid"
                : ""
            }`}
            label="Purchase From"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].purchaseDate`}
            type="date"
            placeholder="Purchase Date"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.purchaseDate
                ? "is-invalid"
                : ""
            }`}
            label="Purchase Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="Purchase Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("purchaseDate"), "YYYY-MM-DD") || ""}
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].coeCost`}
            type="text"
            placeholder="COE Cost"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.coeCost
                ? "is-invalid"
                : ""
            }`}
            label="COE Cost"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].coeExpiryDate`}
            type="date"
            placeholder="COE Expiry Date"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.coeExpiryDate
                ? "is-invalid"
                : ""
            }`}
            label="COE Expiry Date"
            labelClassName="form-label"
            required={true}
            requiredMessage="COE Expiry Date is required"
            dateFormat="YYYY-MM-DD"
            // defaultValue={dayjs(watch("coeExpiryDate"), "YYYY-MM-DD") || null}
          />
        </div>
      </div>

      <div className="form-row row">
        <h4 className="header-title">Driver</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].driverName`}
            type="text"
            placeholder="Driver Name"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.driverName
                ? "is-invalid"
                : ""
            }`}
            label="Driver Name"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].driverContactNo`}
            type="text"
            placeholder="Driver Contact Number"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.driverContactNo
                ? "is-invalid"
                : ""
            }`}
            label="Driver Contact Number"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].statusNationalityAndWPSPass`}
            type="text"
            placeholder="Status Nationality and WPS Pass"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]
                ?.statusNationalityAndWPSPass
                ? "is-invalid"
                : ""
            }`}
            label="Status, Nationality and WPS Pass"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>
      </div>

      <div className="form-row row">
        <h4 className="header-title">Job</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].jobSite`}
            type="text"
            placeholder="Job Site"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.jobSite
                ? "is-invalid"
                : ""
            }`}
            label="Job Site"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].jobNumber`}
            type="text"
            placeholder="Job Number"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.jobNumber
                ? "is-invalid"
                : ""
            }`}
            label="Job Number"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>
      </div>

      <div className="form-row row">
        <h4 className="header-title">Diesel</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].dieselAmount`}
            type="text"
            placeholder="Diesel Amount"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.dieselAmount
                ? "is-invalid"
                : ""
            }`}
            label="Diesel Amount"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].dieselTopupAmount`}
            type="text"
            placeholder="Diesel Top-up Amount"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.dieselTopupAmount
                ? "is-invalid"
                : ""
            }`}
            label="Diesel Top-up Amount"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>
      </div>

      <div className="form-row row">
        <h4 className="header-title">Rental</h4>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].rentalDriverCost`}
            type="text"
            placeholder="Rental Driver Cost"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.rentalDriverCost
                ? "is-invalid"
                : ""
            }`}
            label="Rental Driver Cost"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>

        <div className="col-md-4 col-sg-12 mb-3">
          <Input
            name={`vehicleInformationList[${index}].rentalVehicleCost`}
            type="text"
            placeholder="Rental Vehicle Cost"
            className={`form-control ${
              errors?.vehicleInformationList?.[`${index}`]?.rentalVehicleCost
                ? "is-invalid"
                : ""
            }`}
            label="Rental Vehicle Cost"
            labelClassName="form-label"
            defaultValue=""
          />
        </div>
      </div>

      {/* <div className="col-md-4 col-sg-12 mb-3">
        <Input
          name={`vehicleInformationList[${index}].isActive"
          type="commonSelect"
          placeholder="Select Status"
          className={`form-control select ${
             errors?.vehicleInformationList?.[
                    `${index}`
                  ]?.isActive ? "is-invalid" : ""
          }`}
          label="Status"
          labelClassName="form-label"
          optionData={isStatusOption}
          required={true}
          requiredMessage="Status is required"
          onChange={(selectedOption) => {
            setValue("isActive", selectedOption?.value);
            trigger("isActive");
          }}
          defaultValue={watch("isActive")}
        />
      </div> */}
      <InputWarningMessage
        message="*All mandatory fields to be entered to Save the record."
        type="danger"
      />
    </>
  );
};
Vehicle.propTypes = {
  companyCode: PropTypes.number.isRequired,
};
export default React.memo(Vehicle);
